export enum DescriptionType {
  BIG = 'big',
  MEDIUM = 'medium',
  SMALL = 'small',
  SMALL_DARK = 'smallDark',
  POPUP = 'popup',
}
